'use strict';

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var SvgIcon = require('@mui/material/SvgIcon');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var SvgIcon__default = /*#__PURE__*/_interopDefaultLegacy(SvgIcon);

var Flow = function Flow(props) {
  return /*#__PURE__*/React__default["default"].createElement(SvgIcon__default["default"], _rollupPluginBabelHelpers["extends"]({
    viewBox: "0 0 270 250"
  }, props), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M33.75 104.14h45.83c4.4 0 8 3.6 8 8v27.5c0 4.4-3.6 8-8 8H33.75c-4.4 0-8-3.6-8-8v-27.5c0-4.4 3.6-8 8-8z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M79.58 150.89H33.75c-6.21 0-11.25-5.05-11.25-11.25v-27.5c0-6.21 5.05-11.25 11.25-11.25h45.83c6.21 0 11.25 5.05 11.25 11.25v27.5c.01 6.2-5.04 11.25-11.25 11.25zm-45.83-43.5c-2.62 0-4.75 2.13-4.75 4.75v27.5c0 2.62 2.13 4.75 4.75 4.75h45.83c2.62 0 4.75-2.13 4.75-4.75v-27.5c0-2.62-2.13-4.75-4.75-4.75H33.75z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M190.42 15.75h45.83c4.4 0 8 3.6 8 8v27.5c0 4.4-3.6 8-8 8h-45.83c-4.4 0-8-3.6-8-8v-27.5c0-4.4 3.6-8 8-8z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M236.25 62.51h-45.83c-6.21 0-11.25-5.05-11.25-11.25v-27.5c0-6.21 5.05-11.25 11.25-11.25h45.83c6.21 0 11.25 5.05 11.25 11.25v27.5c0 6.2-5.05 11.25-11.25 11.25zm-45.83-43.5c-2.62 0-4.75 2.13-4.75 4.75v27.5c0 2.62 2.13 4.75 4.75 4.75h45.83c2.62 0 4.75-2.13 4.75-4.75v-27.5c0-2.62-2.13-4.75-4.75-4.75h-45.83z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M190.42 234.25h45.83c4.4 0 8-3.6 8-8v-27.5c0-4.4-3.6-8-8-8h-45.83c-4.4 0-8 3.6-8 8v27.5c0 4.4 3.6 8 8 8z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M236.25 237.5h-45.83c-6.21 0-11.25-5.05-11.25-11.25v-27.5c0-6.21 5.05-11.25 11.25-11.25h45.83c6.21 0 11.25 5.05 11.25 11.25v27.5c0 6.2-5.05 11.25-11.25 11.25zM190.42 194c-2.62 0-4.75 2.13-4.75 4.75v27.5c0 2.62 2.13 4.75 4.75 4.75h45.83c2.62 0 4.75-2.13 4.75-4.75v-27.5c0-2.62-2.13-4.75-4.75-4.75h-45.83zM88.1 130.77c-1.5 0-3.03-.07-4.6-.22l.96-10.37c26.09 2.43 40.43-22.82 54.31-47.23 12.81-22.53 26.06-45.82 48.9-41.36l-1.99 10.22C170.16 38.79 159.81 57 147.82 78.1c-14.08 24.76-29.95 52.67-59.72 52.67z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M182.11 220.73c-19.52 0-31.61-21.28-43.35-41.92-13.88-24.41-28.23-49.66-54.31-47.23l-.96-10.37c32.81-3.04 49.53 26.44 64.32 52.45 12 21.09 22.32 39.32 37.86 36.29l1.99 10.22c-1.91.38-3.76.56-5.55.56z"
  }));
};
Flow.propTypes = SvgIcon__default["default"].propTypes;

module.exports = Flow;
